const Admin = () => {
  window.location.href = process.env.REACT_APP_SERVER_URL+"admin/login";
};

export default Admin;
